import { render } from "./quotation.vue?vue&type=template&id=35e3f684"
import script from "./quotation.vue?vue&type=script&lang=js"
export * from "./quotation.vue?vue&type=script&lang=js"

import "./quotation.vue?vue&type=style&index=0&id=35e3f684&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/levelup/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__